import React from 'react';
import styled from 'styled-components';

function UnitTextCell(props) {
  const { cell } = props;
  const { row, column } = cell;
  const { field } = column;
  let displayValue = row?.original[field?.name]?.value;
  if (!displayValue) {
    displayValue = row?.original[field?.name]?.byteConv;
  }
  if (!displayValue && displayValue !== 0) {
    displayValue = 'NA';
  }
  return (
    <div className="flex center">
      {`${displayValue} ${row?.original[field?.name]?.unit || ''}`}
    </div>
  );
}

export default UnitTextCell;
